var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2427 5.68858L19.2427 5.6892C19.3287 7.49768 18.648 9.61584 17.2471 11.6404L17.2471 11.6404C15.6417 13.9605 13.146 16.0712 9.99875 17.7245C6.85174 16.0713 4.35643 13.9606 2.7517 11.6404C1.3515 9.61597 0.671074 7.49772 0.757297 5.68873L0.757331 5.68801C0.819615 4.35422 1.35292 3.11477 2.24972 2.19327C3.15195 1.26623 4.32016 0.761083 5.53988 0.75H5.54152C6.55749 0.75 7.48965 1.11147 8.33196 1.86331C8.70256 2.19412 9.0538 2.59997 9.37884 3.08039L10.0001 3.99859L10.6212 3.08033C10.9462 2.59995 11.2975 2.19414 11.6681 1.8633C12.5104 1.11147 13.4426 0.75 14.4585 0.75H14.4601C15.6798 0.761049 16.8481 1.26619 17.7503 2.19326C18.647 3.11469 19.1804 4.35418 19.2427 5.68858Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.14b41add17f4f06313fafdfc1a3d553a.svg";
export { ForwardRef as ReactComponent };